(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["audience-switcher"] && !Shopify.designMode) return;
  try {
    (function () {
    const STORAGE_KEY = 'bondit_audience';
    const DEFAULT_AUDIENCE = window.themeSettings?.defaultAudience || 'trade';

    function getAudience() {
      return localStorage.getItem(STORAGE_KEY) || DEFAULT_AUDIENCE;
    }

    function setAudience(audience) {
      localStorage.setItem(STORAGE_KEY, audience);
      document.documentElement.dataset.audience = audience;
      // Update the toggle's own visual state immediately so the tap feels
      // responsive, then defer the heavier section-by-section pass (it can
      // touch every section on the page) to the next frame instead of
      // blocking this click handler.
      updateSwitchers(audience);

      requestAnimationFrame(function () {
        updateSectionVisibility(audience);

        document.dispatchEvent(
          new CustomEvent('audience:changed', {
            detail: { audience },
          })
        );
      });
    }

    function updateSwitchers(audience) {
      document.querySelectorAll('[data-audience-switcher]').forEach((switcher) => {
        switcher.querySelectorAll('[data-audience]').forEach((btn) => {
          btn.setAttribute('aria-pressed', btn.dataset.audience === audience);
        });
      });
    }

    function updateSectionVisibility(audience) {
      document.querySelectorAll('[data-section-visibility]').forEach((section) => {
        const visibility = section.dataset.sectionVisibility;
        if (visibility === 'both') {
          section.style.display = '';
        } else if (visibility === audience) {
          section.style.display = '';
        } else {
          section.style.display = 'none';
        }
      });
    }

    function init() {
      if (window.themeSettings?.customerLoggedIn) {
        setAudience('trade');
        return;
      }

      const audience = getAudience();
      document.documentElement.dataset.audience = audience;
      updateSwitchers(audience);
      updateSectionVisibility(audience);

      document.querySelectorAll('[data-audience-switcher] [data-audience]').forEach((btn) => {
        btn.addEventListener('click', () => {
          setAudience(btn.dataset.audience);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Expose for external use
    window.BonditAudience = {
      get: getAudience,
      set: setAudience,
    };
  })();
  } catch(e) { console.error(e); }
})();

})();
